import React, { FC } from "react";
import { JobPostEditorSectionLayout } from "@components/Layout/JobPostEditorSectionLayout";
import { useFormContext } from "react-hook-form";
import { Input } from "@components/Form/Input";
import { classNames } from "@utils/classNames";
import { TextEditor } from "@components/TextEditor/TextEditor";
import { ErrorMessage } from "@hookform/error-message";
import { defaultErrorMessageCN } from "@components/Form/Styles";
import get from "lodash/get";
import { TagsGroup } from "@components/TagsGroup/TagsGroup";
import { NewTag, TagType } from "types/tags";

interface Props {
  tags: NewTag[];
}

export const DescriptionSection: FC<Props> = ({ tags }) => {
  const {
    getValues,
    watch,
    setValue,
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext();
  const { jobPost } = getValues();

  return (
    <JobPostEditorSectionLayout title="" description="">
      <div className="col-span-6">
        <Input
          label="Title"
          path="jobPost.title"
          register={register}
          errors={errors}
        />
      </div>

      <div className="col-span-6 sm:col-span-6 lg:col-span-2 mt-6">
        <TagsGroup
          heading="Role"
          availableTagTypes={[TagType.ROLE]}
          tags={tags}
          name="jobPost.userAssignedTags"
        />
      </div>

      <div className="col-span-6 sm:col-span-6 lg:col-span-2 mt-6">
        <TagsGroup
          heading="Experience"
          availableTagTypes={[TagType.EXPERIENCE_LEVEL]}
          tags={tags}
          name="jobPost.userAssignedTags"
        />
      </div>

      <div className="col-span-6 sm:col-span-6 lg:col-span-2 mt-6">
        <TagsGroup
          heading="Employment type"
          availableTagTypes={[TagType.EMPLOYMENT_TYPE]}
          tags={tags}
          name="jobPost.userAssignedTags"
        />
      </div>

      <div className="col-span-6 sm:col-span-6 lg:col-span-2 mt-6">
        <label
          htmlFor="jobPost.description"
          className="block text-sm font-medium text-gray-700"
        >
          Description
        </label>
        <div
          className={classNames(
            get(errors, "jobPost.description")
              ? "bg-red-50 border-red-500"
              : "",
            "mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"
          )}
        >
          <TextEditor
            content={jobPost?.description || ``}
            onUpdate={(e) => {
              clearErrors("jobPost.description"),
                setValue("jobPost.description", e);
            }}
          />
        </div>
        <ErrorMessage
          errors={errors}
          name="jobPost.description"
          render={({ message }) => (
            <p className={defaultErrorMessageCN}>{message}</p>
          )}
        />
      </div>
    </JobPostEditorSectionLayout>
  );
};
